import { Phone, Mail, MapPin, Calendar, CreditCard, Truck } from "lucide-react";
import { Container } from "@/components/ui/Container";
import { Button } from "@/components/ui/Button";
import { useScrollTo } from "@/hooks/useScrollTo";
import { BUSINESS, NAV_LINKS, SERVICES, logo } from "@/utils/constants";

export const Footer = () => {
  const scrollTo = useScrollTo();

  return (
    <footer data-testid="footer" className="relative bg-[#070707] border-t border-white/5 pt-16 pb-8">
      <Container className="grid gap-10 md:grid-cols-12">
        <div className="md:col-span-4">
          <img src={logo} alt="Deuce's Welding & Fabrication logo" className="h-28 w-auto mb-4 rounded-lg" />
          <p className="text-weld-glow font-display text-2xl">{BUSINESS.tagline}</p>
          <p className="text-white/50 max-w-xs text-sm leading-relaxed mt-3">
            Professional mobile welding & custom fabrication you can trust.
          </p>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-white font-bold uppercase tracking-wider text-sm mb-4">Quick Links</h4>
          <ul className="flex flex-col gap-2">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <button onClick={() => scrollTo(l.to)} className="text-white/50 hover:text-weld-glow text-sm transition-colors">{l.label}</button>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-white font-bold uppercase tracking-wider text-sm mb-4">Services</h4>
          <ul className="grid grid-cols-1 gap-2">
            {SERVICES.slice(0, 6).map((s) => (
              <li key={s.title} className="text-white/50 text-sm">{s.title}</li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-white font-bold uppercase tracking-wider text-sm mb-4">Contact & Area</h4>
          <ul className="flex flex-col gap-3 text-sm">
            <li>
              <a href={BUSINESS.phoneHref} className="flex items-center gap-2 text-white/50 hover:text-weld-glow transition-colors">
                <Phone size={15} /> {BUSINESS.phone}
              </a>
            </li>
            <li>
              <a href={BUSINESS.emailHref} className="flex items-center gap-2 text-white/50 hover:text-weld-glow transition-colors break-all">
                <Mail size={15} /> {BUSINESS.email}
              </a>
            </li>
            <li className="flex items-center gap-2 text-white/50"><MapPin size={15} /> Serving {BUSINESS.area}</li>
            <li className="flex items-center gap-2 text-white/50"><Truck size={15} /> Fully Mobile Service</li>
          </ul>
          <div className="flex gap-3 mt-5">
            <Button size="sm" href={BUSINESS.bookUrl} target="_blank" rel="noopener noreferrer">
              <Calendar size={14} /> Book
            </Button>
            <Button variant="outline" size="sm" href={BUSINESS.depositUrl} target="_blank" rel="noopener noreferrer">
              <CreditCard size={14} /> Deposit
            </Button>
          </div>
        </div>
      </Container>

      <Container className="mt-12 pt-6 border-t border-white/5 flex flex-col sm:flex-row justify-between items-center gap-3">
        <p className="text-white/30 text-xs">© {new Date().getFullYear()} {BUSINESS.name} Welding & Fabrication. All rights reserved.</p>
        <p className="text-white/30 text-xs flex items-center gap-4">
          <span>Secure payments powered by Square.</span>
          <a href="/admin" data-testid="owner-login-link" className="text-white/20 hover:text-weld-glow transition-colors">Owner Login</a>
        </p>
      </Container>
    </footer>
  );
};
